import React, { useEffect } from 'react';
import { Account } from './components/account/Account';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/auth-hooks';
import { createStyles, makeStyles } from '@mui/styles';
import { Box, Theme, Typography, LinearProgress } from '@mui/material';
import { useStore } from '@cobuildlab/react-simple-state';
import { changeStepStore } from './onboarding-events';
import { CreateAccount } from './components/create-account/CreateAccount';
import { changeStep } from './onboarding-actions';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const useStyles = makeStyles<Theme>(() =>
  createStyles({
    cleanButton: {
      background: 'none!important',
      border: 'none!important',
      cursor: 'pointer',
      color: '#000!important',
      height: 30,
      width: 30,
      margin: '0 0',
    },
    eventsNone: {
      pointerEvents: 'none',
    },
  }),
);

const STEPS = 2;

export const Onboarding: React.FC = () => {


  const navigate = useNavigate();
  const { user } = useAuth();
  const { step } = useStore(changeStepStore);
  const classes = useStyles();

  useEffect(() => {
    if (user?.meta_api_cloud_account) {
      navigate('/');
    }

  }, [navigate, user]);

  let content = <></>;


  switch (step) {
    case 1:
      content = <CreateAccount />;
      break;
    case 2:
      content = <Account />;
      break;

  }

  return (
    <div>
      <Box
        position={'relative'}
        height={'80px'}
        paddingX={'10px'}
        display={'flex'}
        justifyContent={'justify-between'}
        alignItems={'center'}
      >
        <Box
          className={classes.eventsNone}
          width={'100%'}
          position={'absolute'}
          top={0}
          left={'-2px'}
          height={'80px'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Box
            height={'100%'}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Typography fontWeight={600}>Account Setup</Typography>
            <Typography fontWeight={600} fontSize={14}>
              Step {step + '/' + STEPS}
            </Typography>
          </Box>
        </Box>
        <button
          className={classes.cleanButton}
          onClick={() => {
            if (step > 1) {
              changeStep(step - 1);
            }
          }}
        >
          <ArrowBackIcon fontSize='small' />
        </button>
      </Box>
      <LinearProgress
        sx={{
          height: 8,
          borderRadius: 5,

          backgroundColor: 'white',
          '& .MuiLinearProgress-bar': {
            backgroundColor: '#44DD29',
            borderRadius: 5,
          },
        }}
        variant='determinate'
        value={(100 / STEPS) * step}
      />
      <Box>{content}</Box>
    </div>
  );
};
